import { RootState } from '../store'
export const selectAuthState = (state: RootState) => state.auth
export const selectAuthenticated = (state: RootState) =>
  state.auth.authenticated
export const selectUsername = (state: RootState) => state.auth.username
export const selectToken = (state: RootState) => state.auth.token
export const selectLoading = (state: RootState) => state.auth.loading
export const selectError = (state: RootState) => state.auth.error
